// src/i18n/translations.js
// All UI strings in English and Arabic
// Usage: t('Add to Cart', 'أضف إلى السلة')
// Or:    const { lang, t, isAr } = useLanguage();
//        t(strings.addToCart)

export const strings = {
  // ── Nav ────────────────────────────────────────────────────
  kiosk:          { en: '🛒 Kiosk',        ar: '🛒 الكشك'        },
  multiVendor:    { en: '🏬 Multi-Vendor', ar: '🏬 متعدد البائعين' },
  orders:         { en: '📋 Orders',       ar: '📋 الطلبات'       },
  kitchen:        { en: '👨‍🍳 Kitchen',    ar: '👨‍🍳 المطبخ'      },
  billing:        { en: '💳 Billing',      ar: '💳 الفواتير'      },
  vendorAdmin:    { en: '🍽 Vendor Admin', ar: '🍽 إدارة البائع'  },
  promos:         { en: '🎟 Promos',       ar: '🎟 العروض'        },
  analytics:      { en: '📊 Analytics',   ar: '📊 التحليلات'     },
  mallAdmin:      { en: '🏛 Mall Admin',  ar: '🏛 إدارة المول'   },
  logout:         { en: 'Logout',         ar: 'تسجيل الخروج'     },
  customerMode:   { en: '👤 Customer Mode', ar: '👤 وضع الزبون'  },
  install:        { en: '📲 Install',     ar: '📲 تثبيت'         },
  offline:        { en: '📶 Offline',     ar: '📶 غير متصل'      },

  // ── Kiosk ─────────────────────────────────────────────────
  whatCraving:    { en: 'What are you craving today?', ar: 'ماذا تشتهي اليوم؟' },
  itemsAvailable: { en: 'items available',             ar: 'عنصر متاح'          },
  searchMenu:     { en: '🔍 Search menu...',           ar: '🔍 ابحث في القائمة...' },
  allCategories:  { en: 'All',                         ar: 'الكل'               },
  addToCart:      { en: 'Add +',                       ar: '+ أضف'              },
  customise:      { en: 'Customise +',                 ar: '+ تخصيص'            },
  yourCart:       { en: '🛒 Your Cart',                ar: '🛒 سلتك'            },
  items:          { en: 'items',                       ar: 'عناصر'              },
  addItemsToStart:{ en: 'Add items to start your order', ar: 'أضف عناصر لبدء طلبك' },
  subtotal:       { en: 'Subtotal',                   ar: 'المجموع الفرعي'     },
  vat:            { en: 'VAT (5%)',                   ar: 'ضريبة القيمة المضافة (٥٪)' },
  discount:       { en: 'Discount',                   ar: 'خصم'                },
  total:          { en: 'Total',                      ar: 'الإجمالي'           },
  proceedPayment: { en: '💳 Proceed to Payment →',   ar: '← المضي نحو الدفع 💳' },
  promoCode:      { en: 'Promo code',                 ar: 'رمز الخصم'          },
  apply:          { en: 'Apply',                      ar: 'تطبيق'              },
  applied:        { en: 'applied',                    ar: 'مطبق'               },
  fromPrice:      { en: 'from',                       ar: 'من'                 },
  loading:        { en: 'Loading menu...',            ar: 'جارٍ تحميل القائمة...' },
  noItems:        { en: 'No items found',             ar: 'لا توجد عناصر'      },
  tableNo:        { en: 'Table',                      ar: 'طاولة'              },

  // ── Order success ─────────────────────────────────────────
  orderPlaced:    { en: 'Order Placed & Paid!',       ar: 'تم تقديم الطلب والدفع!' },
  orderPrepared:  { en: 'Your order is being prepared.', ar: 'طلبك قيد التحضير.' },
  payAtCounter:   { en: 'Pay at the Counter',          ar: 'ادفع عند الكاونتر' },
  payAtCounterMsg:{ en: 'Pay cash at the counter. Preparation starts once payment is received.', ar: 'ادفع نقدًا عند الكاونتر. يبدأ التحضير بعد استلام الدفع.' },
  returningIn:    { en: 'Returning to menu in',       ar: 'العودة إلى القائمة خلال' },
  seconds:        { en: 's...',                       ar: 'ثانية...'           },

  // ── Idle screen ───────────────────────────────────────────
  tapToOrder:     { en: '👆 TAP TO ORDER',            ar: 'اضغط للطلب 👆'      },
  welcome:        { en: 'Welcome to',                 ar: 'مرحباً بك في'       },

  // ── Modifier selector ─────────────────────────────────────
  customizeOrder: { en: 'Customize your order',       ar: 'خصّص طلبك'          },
  chooseOne:      { en: 'Choose one',                 ar: 'اختر واحداً'        },
  chooseUpTo:     { en: 'Choose up to',               ar: 'اختر حتى'           },
  required:       { en: '(required)',                 ar: '(مطلوب)'            },
  optional:       { en: '(optional)',                 ar: '(اختياري)'          },
  free:           { en: 'Free',                       ar: 'مجاناً'             },
  addToCartBtn:   { en: '+ Add to Cart',              ar: '+ أضف للسلة'        },
  completeRequired: { en: 'Complete Required',        ar: 'أكمل الحقول المطلوبة' },
  back:           { en: '← Back',                    ar: 'رجوع →'             },
  next:           { en: 'Next →',                    ar: '← التالي'           },

  // ── Payment ───────────────────────────────────────────────
  selectPayment:  { en: '💳 Select Payment',          ar: '💳 اختر طريقة الدفع' },
  enterCard:      { en: '💳 Enter Card Details',      ar: '💳 أدخل بيانات البطاقة' },
  confirmPayment: { en: '✓ Confirm Payment',          ar: '✓ تأكيد الدفع'      },
  processing:     { en: '⏳ Processing...',            ar: '⏳ جارٍ المعالجة...' },
  paymentApproved:{ en: 'Payment Approved!',          ar: 'تمت الموافقة على الدفع!' },
  paymentFailed:  { en: 'Payment Failed',             ar: 'فشل الدفع'          },
  tryAgain:       { en: 'Try Again',                  ar: 'حاول مجدداً'        },
  cancel:         { en: 'Cancel',                     ar: 'إلغاء'              },
  pay:            { en: 'Pay',                        ar: 'ادفع'               },
  orderSummary:   { en: 'Order Summary',              ar: 'ملخص الطلب'         },
  paymentMethod:  { en: 'Payment Method',             ar: 'طريقة الدفع'        },
  cardNumber:     { en: 'Card Number',                ar: 'رقم البطاقة'        },
  expiryDate:     { en: 'Expiry Date',               ar: 'تاريخ الانتهاء'     },
  cvv:            { en: 'CVV',                        ar: 'رمز الأمان'         },
  cardholderName: { en: 'Cardholder Name',            ar: 'اسم حامل البطاقة'   },
  confirmReceived:{ en: '✓ Confirm Received',         ar: '✓ تأكيد الاستلام'   },
  collectCash:    { en: 'Collect Cash Payment',       ar: 'تحصيل الدفع النقدي' },
  scanQR:         { en: 'Scan QR Code to Pay',        ar: 'امسح رمز QR للدفع'  },

  // ── Multi-vendor ──────────────────────────────────────────
  selectStall:    { en: 'Select a stall to start ordering', ar: 'اختر بسطة لبدء الطلب' },
  tapToBrowse:    { en: 'Tap to browse →',            ar: '← اضغط للتصفح'      },
  inCart:         { en: 'in cart',                    ar: 'في السلة'           },
  allStalls:      { en: '← All Stalls',               ar: 'جميع البسطات →'     },
  addAnotherStall:{ en: '+ Add from Another Stall',   ar: '+ أضف من بسطة أخرى' },
  grandTotal:     { en: 'Grand Total',                ar: 'المجموع الكلي'      },
  stalls:         { en: 'stalls',                     ar: 'بسطة'              },
  placeOrders:    { en: 'Place Orders →',             ar: '← تقديم الطلبات'   },
  proceedToPayment: { en: 'Proceed to Payment →',     ar: '← المضي نحو الدفع' },
  allOrdersPlaced:{ en: 'All Orders Placed!',         ar: 'تم تقديم جميع الطلبات!' },
  startNewOrder:  { en: 'Start New Order',            ar: 'ابدأ طلباً جديداً'  },
  payEachStall:   { en: 'Pay Each Stall',             ar: 'ادفع لكل بسطة'     },
  paid:           { en: '✅ Paid',                    ar: '✅ مدفوع'           },
  reviewCheckout: { en: 'Review & Checkout',          ar: 'مراجعة وإتمام الشراء' },

  // ── Receipt ───────────────────────────────────────────────
  receipt:        { en: 'Receipt',                    ar: 'الإيصال'           },
  order:          { en: 'Order',                      ar: 'الطلب'             },
  printReceipt:   { en: '🖨 Print Receipt',           ar: '🖨 طباعة الإيصال'  },
  emailReceipt:   { en: '📧 Email Receipt',           ar: '📧 إرسال الإيصال'  },
  thankYou:       { en: 'Thank you for your order!',  ar: 'شكراً على طلبك!'   },
};

export default strings;
